import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"card-header border-0 pt-5\"><h3 class=\"card-title align-items-start flex-column\"><span class=\"card-label fw-bolder fs-3 mb-1\">Latest Orders</span><span class=\"text-muted mt-1 fw-bold fs-7\">More than 100 new orders</span></h3><div class=\"card-toolbar\"><ul class=\"nav\"><li class=\"nav-item\"><a class=\"\n                nav-link\n                btn btn-sm btn-color-muted btn-active btn-active-light-primary\n                active\n                fw-bolder\n                px-4\n                me-1\n              \" data-bs-toggle=\"tab\" href=\"#kt_table_widget_7_tab_1\">Month</a></li><li class=\"nav-item\"><a class=\"\n                nav-link\n                btn btn-sm btn-color-muted btn-active btn-active-light-primary\n                fw-bolder\n                px-4\n                me-1\n              \" data-bs-toggle=\"tab\" href=\"#kt_table_widget_7_tab_2\">Week</a></li><li class=\"nav-item\"><a class=\"\n                nav-link\n                btn btn-sm btn-color-muted btn-active btn-active-light-primary\n                fw-bolder\n                px-4\n              \" data-bs-toggle=\"tab\" href=\"#kt_table_widget_7_tab_3\">Day</a></li></ul></div></div>", 1)
const _hoisted_2 = { class: "card-body py-3" }
const _hoisted_3 = { class: "tab-content" }
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = { class: "table align-middle gs-0 gy-3" }
const _hoisted_6 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", { class: "p-0 w-50px" }),
    /*#__PURE__*/_createVNode("th", { class: "p-0 min-w-150px" }),
    /*#__PURE__*/_createVNode("th", { class: "p-0 min-w-140px" }),
    /*#__PURE__*/_createVNode("th", { class: "p-0 min-w-120px" })
  ])
], -1)
const _hoisted_7 = { class: "symbol symbol-50px me-2" }
const _hoisted_8 = {
  href: "#",
  class: "\n                            text-dark\n                            fw-bolder\n                            text-hover-primary\n                            mb-1\n                            fs-6\n                          "
}
const _hoisted_9 = { class: "text-muted fw-bold d-block fs-7" }
const _hoisted_10 = { class: "text-end" }
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "text-muted fw-bold d-block fs-8" }, "Ordered", -1)
const _hoisted_12 = { class: "text-dark fw-bolder d-block fs-7" }
const _hoisted_13 = { class: "text-end" }
const _hoisted_14 = /*#__PURE__*/_createVNode("td", { class: "text-end" }, [
  /*#__PURE__*/_createVNode("a", {
    href: "#",
    class: "\n                            btn\n                            btn-sm\n                            btn-icon\n                            btn-bg-light\n                            btn-active-color-primary\n                          "
  }, [
    /*#__PURE__*/_createVNode("i", { class: "bi bi-three-dots fs-5" })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createBlock("div", {
    class: [_ctx.widgetClasses, "card"]
  }, [
    _hoisted_1,
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
          return (_openBlock(), _createBlock("div", {
            key: index,
            class: [[index === 0 && 'active show'], "tab-pane fade"],
            id: `kt_table_widget_7_tab_${index + 1}`
          }, [
            _createVNode("div", _hoisted_4, [
              _createVNode("table", _hoisted_5, [
                _hoisted_6,
                _createVNode("tbody", null, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(item, (item1, index1) => {
                    return (_openBlock(), _createBlock("tr", { key: index1 }, [
                      _createVNode("td", null, [
                        _createVNode("div", _hoisted_7, [
                          _createVNode("span", {
                            class: [`bg-light-${item1.icon.color}`, "symbol-label"]
                          }, [
                            _createVNode("span", {
                              class: [`svg-icon-${item1.icon.color}`, "svg-icon svg-icon-2x"]
                            }, [
                              _createVNode(_component_inline_svg, {
                                src: item1.icon.file
                              }, null, 8, ["src"])
                            ], 2)
                          ], 2)
                        ])
                      ]),
                      _createVNode("td", null, [
                        _createVNode("a", _hoisted_8, _toDisplayString(item1.info.title), 1),
                        _createVNode("span", _hoisted_9, _toDisplayString(item1.info.description), 1)
                      ]),
                      _createVNode("td", _hoisted_10, [
                        _hoisted_11,
                        _createVNode("span", _hoisted_12, _toDisplayString(item1.date), 1)
                      ]),
                      _createVNode("td", _hoisted_13, [
                        _createVNode("span", {
                          class: [`badge-light-${item1.badge.color}`, "badge fs-7 fw-bolder"]
                        }, _toDisplayString(item1.badge.label), 3)
                      ]),
                      _hoisted_14
                    ]))
                  }), 128))
                ])
              ])
            ])
          ], 10, ["id"]))
        }), 128))
      ])
    ])
  ], 2))
}